import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from 'utils/axiosBaseQuery';

// Define a service using a base URL and expected endpoints
export const shipmentApi = createApi({
  reducerPath: 'shipmentApi',
  baseQuery: axiosBaseQuery(),
  keepUnusedDataFor: 0,
  tagTypes: ['shipment'],
  endpoints: (builder) => ({
    getShipments: builder.query({
      query: ({ id }) => ({
        method: 'GET',
        path: `Shipment/GetShipments/${id}`,
      }),
      providesTags: ['shipment'],
    }),
    getShipmentInfo: builder.query({
      query: ({ id }) => ({
        method: 'GET',
        path: `shipment/GetAShipment/${id}`,
      }),
    }),
    getAddressBook: builder.query({
      query: ({ id }) => ({
        method: 'GET',
        path: `Addresses/GetAddressBook/${id}`,
      }),
    }),
    getAddress: builder.query({
      query: ({ id }) => ({
        method: 'GET',
        path: `Addresses/GetAddress/${id}`,
      }),
    }),
    getBookServices: builder.query({
      query: () => ({
        method: 'GET',
        path: `publicdata/GetKeypairDatas/bookservices`,
      }),
    }),
    getShipmentTypes: builder.query({
      query: () => ({
        method: 'GET',
        path: `publicdata/ShipmentTypes`,
      }),
    }),
    getCurrencyName: builder.query({
      query: () => ({
        method: 'GET',
        path: `CurrencyNames`,
      }),
    }),
    getCustomerInfo: builder.query({
      query: ({ id }) => ({
        method: 'GET',
        path: `Customer/GetCustomer/${id}`,
      }),
    }),
    createShipment: builder.mutation({
      query: ({ data }) => ({
        data,
        method: 'PUT',
        path: 'Shipment/CreateOrUpdateShipment',
      }),
      invalidatesTags: ['shipment'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const shipmentApiReducerName = shipmentApi.reducerPath;
export const shipmentApiReducer = shipmentApi.reducer;
export const shipmentApiMiddleware = shipmentApi.middleware;

export const {
  useGetShipmentsQuery,
  useGetShipmentInfoQuery,
  useGetAddressQuery,
  useGetAddressBookQuery,
  useGetBookServicesQuery,
  useGetShipmentTypesQuery,
  useGetCurrencyNameQuery,
  useGetCustomerInfoQuery,
  useCreateShipmentMutation,
} = shipmentApi;
